<ion-header class="ion-no-border">
  <ion-toolbar>
    @if (step === 'list') {
    <ion-back-button slot="start"></ion-back-button>
    } @else if (!isPaymentProcessing) {
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
    <ion-title>{{ title }}</ion-title>
    @if (step === 'list' && branches?.length) {
    <ion-buttons slot="end">
      <super-button size="v-small" width="fit" type="underline" [action]="startSubscription" [showError]="true">
        Create subscription
      </super-button>
    </ion-buttons>
    }
    @if (step === 'plans') {
    <div slot="end" class="pe-5">
      <ion-segment class="period-segment" [(ngModel)]="paymentTerms" (ngModelChange)="onPeriodChange($event)"
        mode="ios">
        <ion-segment-button [value]="TimePeriod.YEARLY">
          <ion-label>Annual</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="TimePeriod.MONTHLY">
          <ion-label>Monthly</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
    }
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="flex flex-col gap-4 p-4">

    @if (step === 'list') {
    <div class="px-[15px] pt-[15px] pb-5 rounded-md overflow-hidden bg-white">
      @if (branches === null) {
      <ion-skeleton-text class="w-full rounded-md overflow-hidden h-20" [animated]="true"></ion-skeleton-text>
      } @else if (branches.length === 0) {
      <p class="m-0 text-sm text-[var(--ion-color-two)]">No branches yet</p>
      } @else {
      <div class="branch-list cols-3">
        <div class="branch-row header">
          <div>Branch</div>
          <div>Plan</div>
          <div>Expiry</div>
        </div>
        @for (branch of branches; track branch.childOrg._id) {
        <div class="branch-row">
          <div>{{ branch.childOrg?.name || '—' }}</div>
          <div>{{ branch.primaryPurchase?.plan?.name || 'Free Tier' }}</div>
          <div>
            @if (branch.primaryPurchase?.expireTime) {
            {{ branch.primaryPurchase.expireTime | date: 'dd MMM, yyyy' }}
            } @else {
            —
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }

    @if (step === 'accounts') {
    <div class="px-[15px] pt-[15px] pb-5 rounded-md overflow-hidden bg-white">
      <p class="m-0 mb-4 text-sm text-[var(--ion-color-two)]">Choose the branch accounts to include in this order</p>

      <div class="branch-list cols-accounts">
        <div class="branch-row header">
          <div class="checkbox-col">
            <ion-checkbox color="dark" [checked]="allAccountsSelected" (ionChange)="onSelectAllChange($event)">
            </ion-checkbox>
          </div>
          <div>Branch</div>
          <div>Current plan</div>
          <div>Expiry</div>
        </div>
        @for (branch of branches; track branch.childOrg._id) {
        <div class="branch-row">
          <div class="checkbox-col">
            <ion-checkbox color="dark" [(ngModel)]="branch.selected"></ion-checkbox>
          </div>
          <div>{{ branch.childOrg?.name || '—' }}</div>
          <div>{{ branch.primaryPurchase?.plan?.name || 'Free Tier' }}</div>
          <div>
            @if (branch.primaryPurchase?.expireTime) {
            {{ branch.primaryPurchase.expireTime | date: 'dd MMM, yyyy' }}
            } @else {
            —
            }
          </div>
        </div>
        }
      </div>

      <div
        class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between pt-4 mt-4 border-t border-[var(--ion-color-one)]">
        <p class="m-0 text-sm">{{ selectedAccounts.length }} selected</p>
        <super-button size="small" width="fit" [disabled]="selectedAccounts.length === 0" [action]="continueToPlans"
          [showError]="true" iconEnd="chevron-forward">
          Continue
        </super-button>
      </div>
    </div>
    }

    @if (step === 'plans') {
    <div class="px-[15px] pt-[15px] pb-5 rounded-md overflow-hidden bg-white">
      <div class="branch-list cols-plans">
        <div class="branch-row header">
          <div>Branch</div>
          <div>Current plan</div>
          <div>New plan</div>
          <div class="amount-col">Amount</div>
        </div>
        @for (branch of selectedAccounts; track branch.childOrg._id) {
        <div class="branch-row">
          <div class="truncate">{{ branch.childOrg?.name || '—' }}</div>
          <div>{{ branch.primaryPurchase?.plan?.name || 'Free Tier' }}</div>
          <div>
            <select class="plan-select" [(ngModel)]="branch.selectedPlanId" (ngModelChange)="onPlanChange()">
              <option [ngValue]="null">Select plan</option>
              @for (plan of plansForPeriod; track plan._id) {
              <option [ngValue]="plan._id">{{ planOptionLabel(plan) }}</option>
              }
            </select>
          </div>
          <div class="amount-col">
            @let amount = getSelectedAmount(branch);
            @if (amount !== null) {
            ₹{{ amount }}
            } @else {
            —
            }
          </div>
        </div>
        }
      </div>

      @if (priceBreakup) {
      <ng-container [ngTemplateOutlet]="totals"></ng-container>
      }

      <div class="flex justify-end pt-4 mt-2">
        <super-button size="small" width="fit" [disabled]="!canContinueToPayment" [action]="continueToCheckout"
          [showError]="true" iconEnd="chevron-forward">
          Continue to payment
        </super-button>
      </div>
    </div>
    }

    @if (step === 'checkout') {
    <div class="max-w-screen-lg mx-auto w-full py-6">
      <checkout class="h-full w-full" [items]="checkoutItems" [paymentTerms]="paymentTerms"
        (processingStateChange)="isPaymentProcessing = $event" (onSuccess)="onCheckoutSuccess()">
      </checkout>
    </div>
    }

  </div>
</ion-content>

<ng-template #totals>
  <div class="price-breakup">
    <div>
      <span>Subtotal</span>
      <span>₹{{ priceBreakup.subtotal.toFixed(2) }}</span>
    </div>
    <div>
      <span>Discount</span>
      <span>- ₹{{ priceBreakup.discountAmount.toFixed(2) }}</span>
    </div>
    <div>
      <span>GST (18%)</span>
      <span>₹{{ priceBreakup.taxAmount.toFixed(2) }}</span>
    </div>
    <div>
      <span>Total</span>
      <span>₹{{ priceBreakup.payableAmount.toFixed(2) }}</span>
    </div>
  </div>
</ng-template>